<template>
	<div>
		<v-dialog v-model="against_reference" no-click-animation persistent scrollable fullscreen content-class="full-height" lazy transition="dialog-bottom-transition">
        	<v-card flat>
        		<v-toolbar flat fixed>
			      <v-toolbar-side-icon @click="$parent.fn_closeDialog"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
			      <v-toolbar-title class="white--text">Pending Bill/Invoice</v-toolbar-title>
			      <v-spacer></v-spacer>
			      <v-btn icon small :disabled="disableBtn" @click="fn_saveFilledReferences">Done</v-btn>

			      <v-text-field  flat solo placeholder="Search..." v-model="searchValue" slot="extension" ></v-text-field>

				  <v-menu>
						<v-btn slot="activator" icon>
							<v-icon font20>more_vert</v-icon>
						</v-btn>

						<v-list densed two-line nopadding>
							<v-list-tile @click="$parent.fn_markClear(true)">
								<!-- <v-list-tile-action style="min-width: 36px;">
									<v-icon>list</v-icon>
								</v-list-tile-action> -->
								<v-list-tile-content>
									<v-list-tile-title>Close Pending Bill/Invoice</v-list-tile-title>
									<v-list-tile-sub-title>Remove Bill/Invoice from Pending List</v-list-tile-sub-title>	
								</v-list-tile-content>
							</v-list-tile>

							<!-- <v-list-tile @click="$parent.fn_markClear(false)">
								<v-list-tile-action style="min-width: 36px;">
									<v-icon>refresh</v-icon>
								</v-list-tile-action>
								<v-list-tile-content>
									<v-list-tile-title>Reopen Closed Bill/Invoice</v-list-tile-title>	
								</v-list-tile-content>
							</v-list-tile> -->
						</v-list>

					</v-menu>
			    </v-toolbar>


        		<v-card-text nopadding full-height style="padding-top:100px !important" id="scrollable-div">

        			<v-layout pt-2 pb-2 row wrap style="border-bottom:10px #F0F0F0 solid">
        			  	<v-flex xs6 sm6 md6 pl-3>On Account</v-flex>
        				<v-flex xs6 sm6 md6 pr-3 right-align>&#8377; {{onAccount ? $root.numberToLocale(onAccount) : 0}}</v-flex>
        			</v-layout>

        			<v-form data-vv-scope="fields" full-width>

        				<!-- <v-layout row wrap white-background class="amount-item" style="padding:16px;border-bottom:10px #F0F0F0 solid">

	        				<v-flex xs8 sm8 md8 style="display:flex;align-items:flex-end;">
				      			<span>On Account (&#8377;)</span>
				      		</v-flex>
				      		<v-flex xs4 sm4 md4 right-align custom-text-field>
				      			<v-text-field
				      				style="margin-top:6px;"
				      				nomargin
				      				hide-details
	        						@input="fn_referenceTotal"
				      				v-model.number="onAccount" 
				      				label="" 
				      				placeholder=" " 
				      				type="number" 
				      				v-validate="'decimal:2|min_value:0'" 
				               		data-vv-name="onaccount" 
				               		data-vv-as="on account"
				               		:error-messages="errors.collect('fields.onaccount')">
				      			</v-text-field>
				      		</v-flex>
				      		<v-flex xs12 sm12 md12 mt-2 v-if="errors.has('fields.onaccount')">
				      		  	<div class="error--text font-small pa-2 grey-back full-width">
	  	  							{{ errors.first('fields.onaccount') }}
	  	  						</div>
				      		</v-flex>
	        			</v-layout> -->

	        			<!-- <v-checkbox class="select-all-reference" label="Select All" v-model="selectAllRef" @change="fn_selectAllReferences" margin-top-ten style="padding: 0px 16px;border-bottom: 1px #F0F0F0 solid;color: rgba(0,0,0,0.72);" v-if="filteredItems && filteredItems.length"></v-checkbox> -->
        				
        				<div v-for="(item, index) in filteredItems" :key="index">

        					<v-checkbox v-model="item.selected" style="float:left;padding-left:16px;margin-top:10px;" @change="fn_autoFillAmount($event, item)"></v-checkbox>
				      		<div class="reference-items" style="padding-left:56px !important">
				      			<v-layout wrap>
						      		<v-flex xs8 sm8 md8>
						      			<!-- <span>{{item.prefix}}/{{item.baseTransactionNumber}}{{item.suffix ? '/'+item.suffix : ''}}</span> 
						      			-->
						      			<span v-if="item.baseTransactionNumber">{{item.baseTransactionNumber}}</span>
						      			<span v-else>{{item.baseRefNumber ? item.baseRefNumber : ''}}</span>
						      		</v-flex>
						      		<v-flex xs4 sm4 md4 right-align>
						      			<span>{{item.transactionDate | moment("DD-MMM-YYYY")}}</span>
						      		</v-flex>
						      	</v-layout>

								<v-layout wrap v-if="item.baseRefNumber">
						      		<v-flex xs8 sm8 md8>
						      			<span>Bill No.</span>
						      		</v-flex>
						      		<v-flex xs4 sm4 md4 right-align>
						      			<span>{{ item.baseRefNumber }}</span>
						      		</v-flex>
						      	</v-layout>

						      	<v-layout wrap>
						      		<v-flex xs8 sm8 md8>
						      			<span>Bill Amount</span>
						      		</v-flex>
						      		<v-flex xs4 sm4 md4 right-align>
						      			<span>&#8377; {{$root.numberToLocale(item.billAmount)}}</span>
						      		</v-flex>
						      	</v-layout>

						      	<v-layout wrap>
						      		<v-flex xs8 sm8 md8>
						      			<span>Outstanding Amount</span>
						      		</v-flex>
						      		<v-flex xs4 sm4 md4 right-align>
						      			<span>&#8377; {{$root.numberToLocale(item.outStandingAmount)}}</span>
						      		</v-flex>
						      	</v-layout>

						      	<v-layout wrap class="font-weight-bold amount-item">
						      		<v-flex xs8 sm8 md8>
						      			<span>Amount (&#8377;)</span>
						      		</v-flex>
						      		<v-flex xs4 sm4 md4 right-align custom-text-field>
						      			<v-text-field 
						      				hide-details
						      				:prefix="getPrefix(item.transactionListId) == 'minus' ? '(-)' : ''"
						      				 @input="fn_changeAmount(item)"
						      				v-model.number="item.amount" 
						      				label="" 
						      				placeholder=" " 
						      				type="number" 
						      				v-validate="'min_value:0|decimal:2|max_value:'+item.maxValue" 
						               		:data-vv-name="'amount'+index" 
						               		data-vv-as="amount"
						               		:error-messages="errors.collect('fields.amount'+index)"
											step="0.01">
						      					
						      			</v-text-field>
						      		</v-flex>
						      	</v-layout>

								<!-- <div class="font14" :class="[item.dueDays > 0 ? 'redcolor' : 'greencolor']">
									<span v-if="item.dueDays == 0">Due today</span>
									<span v-if="item.dueDays > 0">Due {{item.dueDays}} days</span>
									<span v-else-if="item.dueDays < 0">Due in {{item.dueDays}} days</span>
								</div> -->

				      		</div>

				      		<div class="error--text font-small pa-2 grey-back full-width" v-if="errors.has('fields.amount'+index)">
  	  							{{ errors.first('fields.amount'+index) }}
  	  						</div>

				      		<v-divider v-if="filteredItems.length-1!=index"></v-divider>
				      		
				      	</div>

        			</v-form>

        			<div class="display_msg" v-if="!filteredItems.length">There is no reference item</div>

        		</v-card-text>
        		<v-divider></v-divider>
		        <v-card-actions>
		        	Total
		        	<v-spacer></v-spacer>
					<template v-if="onAccount">&#8377; {{ $root.numberToLocale(referenceTotal + onAccount) }}</template>
					<template v-else>&#8377; {{ $root.numberToLocale(referenceTotal)}}</template>
          			<!-- &#8377; {{$root.numberToLocale(referenceTotal) + onAccount ? onAccount : 0}} -->
		        </v-card-actions>
        	</v-card>
      	</v-dialog>
	</div>
</template>

<script>



export default{
	props:['references', 'saveFilledReferences', 'getPrefix'],
	data(){
		return{
			against_reference: false,
			searchValue:'',
			disableBtn:false,
			// onAccount:null,
			// selectAllRef:null,
			referenceTotal:0,
			hasAmountFilled:false,
			onAccount:0
			// isEmptyAmountField:true
		}
	},
	methods:{
		openDialogWeb: function () {
			this.against_reference = true;
			this.onAccount = null;
			// if(!this.$parent.Form.particularsData.onAccount && !this.$parent.Form.particularsData.references.length){
			// 	this.onAccount = this.$parent.Form.particularsData.amount;
			// }
			// else{
			// 	this.onAccount = this.$parent.Form.particularsData.onAccount;
			// }

			// making textbox empty and checkbox unchecked if no references save yet
			setTimeout(() => {
				this.fn_referenceTotal();
			}, 500);

			this.searchValue = '';
			this.$validator.reset();
		},
		closeDialogWeb: function () {
			this.against_reference = false;
		},
		onScroll: function () {
			let elements = document.getElementsByClassName('error--text');
			let scrollableDiv = document.getElementById('scrollable-div');
			scrollableDiv.scrollTop = elements[0].offsetTop - 120;
		},
		fn_saveFilledReferences: function () {
			if(this.referenceTotal<=0){
				if(this.hasAmountFilled){
					this.showToast("Total should not be negative or zero");
				}
				else{
					this.$parent.fn_closeDialog();	
				}
				return;
			}

			this.disableBtn = true;
		    this.$validator.validateAll('fields').then((result) => {
				if(result){
					if(!this.onAccount){
						this.$parent.Form.amount = this.referenceTotal;
						this.$parent.Form.particularsData.onAccount = null;
						this.$parent.fn_autoFillPaymentMode(this.$parent.Form.amount, true);
					}
					else{
						if(this.referenceTotal){
							this.$parent.Form.particularsData.onAccount = this.roundUpto2Decimals(this.$parent.Form.amount - this.referenceTotal);
						}
					}

					this.saveFilledReferences();
				}
				else{
					this.disableBtn = false;
				}
		    	// if(this.referenceTotal > this.$parent.Form.particularsData.amount){
				// if(this.referenceTotal > this.$parent.Form.amount){
	    		// 	this.disableBtn = false;
	    		// 	this.showToast("Reference total amount shouldn't greater than amount");
	    		// }
	    		// else{
	    		// 	// this.$parent.Form.particularsData.onAccount = this.roundUpto2Decimals(this.$parent.Form.particularsData.amount - this.referenceTotal);
				// 	this.$parent.Form.particularsData.onAccount = this.roundUpto2Decimals(this.$parent.Form.amount - this.referenceTotal);
	        	// 	this.saveFilledReferences();
	    		// }

		    	// if(this.referenceTotal>0){
		    	// 	if(this.referenceTotal > this.$parent.Form.particularsData.amount){
		    	// 		this.disableBtn = false;
		    	// 		this.showToast("Reference total amount shouldn't greater than amount");
		    	// 	}
		    	// 	else{
		    	// 		this.$parent.Form.particularsData.onAccount = this.roundUpto2Decimals(this.$parent.Form.particularsData.amount - this.referenceTotal);
		     //    		this.saveFilledReferences();
		    	// 	}
		    	// }
		    	// else{
		    	// 	this.disableBtn = false;
		    	// 	this.showToast("Invalid reference total");
		    	// }

		    });
		},
		// fn_selectAllReferences: function(val){
		// 	for(let i in this.filteredItems){
		// 		val ? this.filteredItems[i].amount = this.filteredItems[i].outStandingAmount : this.filteredItems[i].amount = null;
		// 	}
		// 	this.fn_referenceTotal();
		// },

		fn_autoFillAmount: function(selected, item){

			// if(item.amount == item.outStandingAmount){
			// let remainingAmount = this.$parent.Form.particularsData.amount - this.referenceTotal;
			// let remainingAmount = this.$parent.Form.amount - this.referenceTotal;

			if(!selected){
				item.amount = null;
				// this.selectAllRef = false;
			}
			else{
				// if(this.referenceTotal < this.$parent.Form.particularsData.amount){
				// if(this.referenceTotal < this.$parent.Form.amount){
				// 	if(item.outStandingAmount > remainingAmount){
				// 		item.amount = remainingAmount;
				// 	}
				// 	else{
				// 		item.amount = item.outStandingAmount;
				// 	}
				// }
				// else{
				// 	item.amount = item.outStandingAmount;
				// }

				if(!this.referenceTotal || this.referenceTotal < this.$parent.Form.amount || !this.$parent.Form.amount){
					if(this.$parent.Form.amount){
						// let onaccount = this.onAccount ? this.onAccount : 0;
						if(this.referenceTotal < this.$parent.Form.amount){
							if(item.outStandingAmount >= Number(this.$parent.Form.amount - this.referenceTotal)){
								item.amount = this.roundUpto2Decimals(Number(this.$parent.Form.amount - this.referenceTotal)).toFixed(2);
							}
							else{
								item.amount = this.roundUpto2Decimals(item.outStandingAmount).toFixed(2);
							}
						}
						// else{
						// 	item.amount = item.outStandingAmount;
						// }
					}
					else{
						item.amount = this.roundUpto2Decimals(item.outStandingAmount).toFixed(2);
					}
				}
				
				
			}

			this.fn_referenceTotal();
		},
		// fn_changeAmount: function(item){
		// 	if(item.amount == item.outStandingAmount)
		// 		item.autoFill = true;
		// 	else
		// 		item.autoFill = false;

		// 	this.fn_referenceTotal();
		// },

		fn_changeAmount: function(item){
			if(item.amount){
				item.selected = true;
			}
			else{
				item.selected = false;
			}
			this.fn_referenceTotal()
		},

		fn_referenceTotal: function(){
			let referenceTotal = 0;
			this.hasAmountFilled = false;
			// this.isEmptyAmountField = true;

			if(this.filteredItems && this.filteredItems.length){
				for(let i=0; i<this.filteredItems.length; i++){

					let prefix = this.getPrefix(this.filteredItems[i].transactionListId);

					if(this.filteredItems[i].amount){

						this.hasAmountFilled = true;

						// calculating reference total
						if(prefix=='minus'){
							referenceTotal -= Number(this.filteredItems[i].amount);
						}
						else{
							referenceTotal += Number(this.filteredItems[i].amount);
						}

					}
				}
			}

			// let onAccount = 0;

			// if(this.onAccount){
			// 	onAccount = this.onAccount;
			// 	this.isEmptyAmountField = false;
			// }
			
			this.referenceTotal = this.roundUpto2Decimals(referenceTotal);

			if(this.$parent.Form.amount){
				if(this.$parent.Form.amount > this.referenceTotal){
					this.onAccount =  this.$parent.Form.amount - this.referenceTotal;
				}
				else{
					this.onAccount = null;
				}

				if(this.referenceTotal < 0){
					this.onAccount = null;
				}
				// if(this.referenceTotal > this.$parent.Form.amount){
				// 	this.onAccount = this.referenceTotal;
				// }
				// else{
				// 	this.onAccount =  this.$parent.Form.amount - this.referenceTotal;
				// }
			}

			// if(this.referenceTotal > this.$parent.Form.particularsData.amount){
			// if(this.referenceTotal > this.$parent.Form.amount){
			// 	this.showToast("Reference total amount shouldn't greater than amount");
			// 	this.showToast("Please adjust references as per amount");
			// }
		}
	},
	computed:{
		filteredItems: function () {
	        let searchText = this.searchValue.toLowerCase();

	        if(this.references && this.references.length){

	        	return this.references.filter(item => {
		          // let name = item.name.toLowerCase();
		          let keyword = searchText.toLowerCase();

		          // let transactionNumberString = item.baseTransactionNumber ? item.baseTransactionNumber.toLowerCase() : '';
		          let transactionNumberString = ''
				  let baseRefNumberString = '';

		          if(item.baseTransactionNumber){
		          	transactionNumberString = item.baseTransactionNumber.toLowerCase();
		          }
		          
				  if(item.baseRefNumber){
					baseRefNumberString = item.baseRefNumber.toLowerCase();	
		          }

		          return transactionNumberString.match(keyword) || baseRefNumberString.match(keyword);
		        });
		        
		    }
		    else{
	        	return [];
	        }
	    }
	    // disableReferences: function(){
	    // 	if(this.$parent.Form.particularsData.amount == this.referenceTotal){
	    // 		return true;
	    // 	}
	    // 	else{
	    // 		return false;
	    // 	}
	    // }
	 //    referenceTotal: function(){
		// 	let total = 0;

		// 	if(this.filteredItems && this.filteredItems.length){
		// 		for(let i=0; i<this.filteredItems.length; i++){

		// 			let prefix = this.getPrefix(this.filteredItems[i].transactionListId);

		// 			if(this.filteredItems[i].amount){

		// 				if(prefix=='minus'){
		// 					total -= this.filteredItems[i].amount;
		// 				}
		// 				else{
		// 					total += this.filteredItems[i].amount;
		// 				}

		// 			}
		// 		}
		// 	}
			
		// 	return this.roundUpto2Decimals(total);
		// }
	}
}
</script>


// WEBPACK FOOTER //
// src/components/transactions/forms/accountbooks/dialogs/dialog_against_reference.vue